import request from "@/utils/request";

// 解析地址簿xml文件
export function parseAddrBook(data) {
    return request({
        url: "/communities/api/addrBook/parseOffline",
        method: "post",
        data
    });
}
// 导出地址簿
export function exportAddrBook(data) {
    return request({
        url: "/communities/api/addrBook/exportOffline",
        method: "post",
        data,
        type: "json",
        responseType: 'blob'
    });
}